import { DROPBOX_APP_KEY } from "@anydo/core";
import once from "lodash/once";

//#region Types
interface IDropbox {
  choose: (options: {
    success: (files: any[]) => void;
    cancel?: () => void;
    multiselect?: boolean;
    extensions?: string[];
    folderselect?: boolean;
    sizeLimit?: number;
  }) => void;
}

declare var Dropbox: IDropbox | void;
//#endregion

export const loadDropbox = once(function loadDropbox() {
  return new Promise<IDropbox>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://www.dropbox.com/static/api/2/dropins.js";
    script.id = "dropboxjs";
    script.setAttribute("data-app-key", DROPBOX_APP_KEY);
    script.async = true;
    script.onerror = reject;
    script.onload = () => {
      if (typeof Dropbox === "undefined") {
        reject(new ReferenceError("Dropbox doesn't exist in the global scope"));
      } else {
        resolve(Dropbox);
      }
    };

    if (document.head) {
      document.head.appendChild(script);
    } else {
      throw new TypeError("loadDropbox(): document.head isn't declared");
    }
  });
});
